import classNames from 'classnames';
import Typography from 'components/generics/texts/Typography';
import ChevronIcon from 'public/assets/icons/chevron_left.svg';
import { HTMLAttributes } from 'react';
import Skeleton from 'react-loading-skeleton';
import classes from './index.module.scss';
import BankConnectionModal from '../BankConnectionModal';

interface Props extends Omit<HTMLAttributes<HTMLDivElement>, 'onClick'> {
  disabled: boolean;
  onClick: () => void;
  disconnectClick: () => void;
  loading: boolean;
  buttonText: string;
  modalOpen: boolean;
  handleClose: () => void;
}

const BankStateRightSection = ({
  modalOpen,
  handleClose,
  disabled,
  onClick,
  loading,
  buttonText,
}: Props) => {
  return (
    <div
      className={classNames(classes.container, !disabled && classes.pressable)}
    >
      {!loading ? (
        <div
          onClick={onClick}
          className={classes.buttonContainer}
        >
          <Typography
            className={classNames(classes.button, disabled && classes.disabled)}
          >
            {buttonText}
          </Typography>
          <ChevronIcon
            className={classNames(classes.icon, disabled && classes.disabled)}
          />
        </div>
      ) : (
        <Skeleton
          width={170}
          height={25}
        />
      )}
      {modalOpen && (
        <BankConnectionModal
          onClose={handleClose}
          modalOpen={modalOpen}
          onClick={() => !disabled && onClick?.()}
          loading={loading}
        />
      )}
    </div>
  );
};

export default BankStateRightSection;
